module.exports = __webpack_public_path__ + "media/images/plans/icon-check-8fee4e72904d014445f5d52fb07d754c.svg";